import { MapContainer, TileLayer } from "react-leaflet";
import { tileSubdomains } from "@/lib/mapTiles";

// Podgląd na żywo kafli mapy w Ustawieniach — remontuje się przy zmianie URL (key),
// dzięki czemu od razu widać czy dostawca/klucz działają.
export default function TilePreview({ url, attr, cls = "" }) {
  if (!url) return null;
  return (
    <div className="relative rounded-md overflow-hidden border border-slate-700" style={{ height: 150 }} data-testid="tile-preview">
      <div className={`w-full h-full ${cls}`}>
        <MapContainer key={url} center={[52.2297, 21.0122]} zoom={12} zoomControl={true}
          attributionControl={true} scrollWheelZoom={false}
          className="w-full h-full" style={{ background: "#0b1120" }}>
          <TileLayer url={url} attribution={attr} subdomains={tileSubdomains(url)} maxZoom={19} />
        </MapContainer>
      </div>
    </div>
  );
}
